import { render, staticRenderFns } from "./page-header.vue?vue&type=template&id=a45edfa8&scoped=true&"
import script from "./page-header.vue?vue&type=script&lang=ts&"
export * from "./page-header.vue?vue&type=script&lang=ts&"
import style0 from "./page-header.vue?vue&type=style&index=0&id=a45edfa8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45edfa8",
  null
  
)

export default component.exports